export default "__VITE_ASSET__FvvLlIM___"